<template>
    <div>
        <div class="my-5">
            <div>
                <label class="block text-xs font-semibold text-gray-700 uppercase tracking-widest mb-2 text-left">
                    Vimeo Url:
                </label>
                <input type="text" class="form-control "  @change="onChange($event)" :value="this.getActiveCanvasObjProps.url" />
            </div>
            
        </div>
    </div>
</template>
<script>
export default {
    name: "VimeoAppSettings",
   
    computed:{
        getActiveCanvasObjProps(){
            return this.$store.getters.getActiveObjectprops
        },
    },
    methods:{
        onChange(e){
            debugger // eslint-disable-line no-debugger
            let value = e.target.value;

            if(value.includes("vimeo.com/")){
                value = "https://player.vimeo.com/video/" + value.split("/").at(-1); 
            
            } else {
                value = e.target.value;
            }
            this.$store.dispatch("setCurrentObjectProperties" , { url: value });
        }
    }

}
</script>